export default "__VITE_ASSET__A2gKovV7__"